"use strict";

exports.__esModule = true;
exports["default"] = exports.PlusIcon = exports.MinusIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _styledSystem = require("styled-system");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _elements = require("../glyphs/elements");

var _custom = _interopRequireDefault(require("../../primitives/custom"));

var _excluded = ["isExpanded", "toggleIsExpanded"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PlusIcon = (0, _styledComponents["default"])(_elements.NavAddPlus).withConfig({
  displayName: "more-button__PlusIcon",
  componentId: "sc-1khc3z5-0"
})(["", ";", ";", ";"], (0, _styledSystem.compose)(_styledSystem.height, _styledSystem.width), _custom["default"], (0, _styles.defaultTransition)(["fill"]));
exports.PlusIcon = PlusIcon;
var MinusIcon = (0, _styledComponents["default"])(_elements.NavRemoveMinus).withConfig({
  displayName: "more-button__MinusIcon",
  componentId: "sc-1khc3z5-1"
})(["", ";", ";", ";"], (0, _styledSystem.compose)(_styledSystem.height, _styledSystem.width), _custom["default"], (0, _styles.defaultTransition)(["fill"]));
exports.MinusIcon = MinusIcon;
var MoreContainer = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "more-button__MoreContainer",
  componentId: "sc-1khc3z5-2"
})(["cursor:pointer;", " &:hover{color:", ";}&:hover ", "{fill:", ";}&:hover ", "{fill:", ";}"], (0, _styles.defaultTransition)(["color"]), function (props) {
  return (0, _styles.themeDarken)(0.15, "blue", props);
}, PlusIcon, function (props) {
  return (0, _styles.themeDarken)(0.15, "blue", props);
}, MinusIcon, function (props) {
  return (0, _styles.themeDarken)(0.15, "blue", props);
});
var propTypes = {
  isExpanded: _propTypes.bool,
  toggleIsExpanded: _propTypes.func
};
/**
 * This component handles the more button rendering for filter-accordion component and result pane component.
 */

var MoreButton = function MoreButton(_ref) {
  var isExpanded = _ref.isExpanded,
      toggleIsExpanded = _ref.toggleIsExpanded,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(MoreContainer, _extends({
    color: "blue",
    onClick: toggleIsExpanded
  }, props), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    as: "span",
    color: "blue",
    justifyContent: "center"
  }, isExpanded ? /*#__PURE__*/_react["default"].createElement(MinusIcon, {
    fill: "blue",
    height: 14,
    width: 14
  }) : /*#__PURE__*/_react["default"].createElement(PlusIcon, {
    fill: "blue",
    height: 14,
    width: 14
  }), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "inherit",
    display: "inline-block",
    fontSize: 1,
    fontWeight: 2,
    letterSpacing: "0.5px",
    lineHeight: 3,
    ml: "4px",
    tag: "p"
  }, isExpanded ? "Less" : "More")));
};

MoreButton.propTypes = propTypes;
MoreButton.displayName = "Modules.MoreButton";
var _default = MoreButton;
exports["default"] = _default;